.sortable__wrapper {
  position: relative;
}

.sortable__wrapper--scrollable {
  border-bottom: 1px solid var(--color-grey-300);
  border-top: 1px solid var(--color-grey-300);
  margin-bottom: 1rem;
  max-height: 21rem;
  overflow-y: auto;
}

.sortable__container {
  --item-min-height: 3.75rem;
  counter-reset: container;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  margin: 1rem 1rem 1rem 0;
  padding: 0;
}

.sortable__drop-target {
  display: flex;
  gap: 1rem;
  min-height: var(--item-min-height);
  position: relative;
}

.sortable__drop-target::before {
  align-items: center;
  content: counter(container);
  counter-increment: container;
  display: flex;
  opacity: 1;
  position: relative;
  transition: opacity 0.25s;
}

.sortable__drop-target--no-number::before {
  content: none;
}

.sortable__drop-target::after {
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}

.sortable__drop-target:last-child::after {
  display: inline;
}

.sortable__sort-item {
  align-items: center;
  border-radius: 0.5rem;
  display: flex;
  gap: 1rem;
  min-height: var(--item-min-height);
  position: relative;
  width: 100%;
  z-index: 0;
}

.sortable__sort-item--grey-200 {
  background-color: var(--color-grey-200);
}

.sortable__sort-item--white {
  background-color: var(--color-uva-white);
}

.sortable__sort-item:focus {
  z-index: 2;
}

.sortable__sort-item--ghost {
  -webkit-user-drag: none;
  margin: 0 1rem;
  opacity: 0.5;
  padding: 0.5rem 0;
  pointer-events: none;
  position: fixed;
  visibility: hidden;
  z-index: 2;
}

.sortable__sort-item__handle {
  appearance: none;
  background: none;
  background-color: var(--color-uva-white);
  border: 0;
  cursor: grab;
  height: 2.625rem;
  width: 2.625rem;
}

.sortable__sort-item__button-container {
  align-items: center;
  background-color: var(--color-grey-300);
  border-left: 1px solid var(--color-grey-300);
  border-radius: 0 0.5rem 0.5rem 0;
  display: flex;
  flex-direction: column;
  inset: 0 0 0 auto;
  margin-right: 1px;
  overflow: hidden;
  position: absolute;
  width: 2.625rem;
  z-index: 20;
}

.sortable__sort-item__button-container[data-touch="false"] {
  display: none;
}

.sortable__sort-item__handle--icon {
  align-items: center;
  display: flex;
  height: 1rem;
  width: 1rem;
}

.sortable__sort-item__handle--up,
.sortable__sort-item__handle--down {
  color: black;
  display: none;
  height: 100%;
  right: 0.5rem;
}

.sortable__sort-item__handle--up {
  transform: rotate(180deg);
}

.sortable__sort-item--dragging .sortable__sort-item__handle {
  cursor: grabbing;
}

.sortable__sort-item__contents {
  align-items: center;
  color: var(--color-uva-black);
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  width: 100%;
}

.sortable__sort-item__contents--handle-right {
  padding-left: 1rem;
  padding-right: 2.5rem;
}

.sortable__handle {
  color: var(--color-grey-700);
  cursor: grab;
  display: flex;
}

.sortable__handle--right {
  position: absolute;
  right: 0.5rem;
}

/** Target touch enabled devices and screen readers */

.sortable__sort-item__button-container[data-touch="true"] {
  gap: 1px;
  justify-content: center;
}

.sortable__sort-item__button-container[data-touch="true"] .sortable__sort-item__handle--up,
.sortable__sort-item__button-container[data-touch="true"] .sortable__sort-item__handle--down {
  align-items: center;
  display: flex;
  justify-content: center;
}

.sortable__visually-hidden {
  border: 0;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  height: 1px;
  margin: 0 -1px -1px 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
